import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DisplayComponent from '../BaseComponents/DisplayComponent';

import './Accordion.module.css';

const AccordionItem = ({ title, openTitle, arrow, open, children }) => {
  const [isOpen, setIsOpen] = useState(open);

  useEffect(
    () => {
      setIsOpen(open);
    },
    [open]
  );

  const handleClick = e => {
    setIsOpen(!isOpen);
  };

  return (
    <div styleName={classNames('item', { open: isOpen, closed: !isOpen })}>
      <button styleName="header" onClick={handleClick}>
        <span styleName="title">{(isOpen && openTitle) || title}</span>
      </button>
      {isOpen && <div styleName="body">{children}</div>}
    </div>
  );
};

const WrappedAccordionItem = DisplayComponent(AccordionItem);

WrappedAccordionItem.propTypes = {
  /** Display with expanded body at first */
  open: PropTypes.bool,
  /** Content of header */
  title: PropTypes.string.isRequired,
  /** Content of header when item is open */
  openTitle: PropTypes.string
};

const Accordion = ({ children, type, background, dark, padding }) => (
  <div
    styleName={classNames('accordion', type, background, {
      dark,
      'padding-medium': padding === 'medium'
    })}
  >
    {children}
  </div>
);

const WrappedAccordion = DisplayComponent(Accordion);

WrappedAccordion.propTypes = {
  /** Any amount of AccordionItems */
  children: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf([AccordionItem])
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        type: PropTypes.oneOf([AccordionItem])
      })
    ),
    PropTypes.element
  ]).isRequired,
  /** Padding of accordion items */
  padding: PropTypes.oneOf(['none', 'medium']),
  /** Style of accordion */
  type: PropTypes.oneOf([
    'plusminus',
    'block-arrow',
    'inline-arrow',
    'filter-list'
  ]),
  /** Whether or not the accordion is on a dark background (useful only if accordion is transparent) */
  dark: PropTypes.bool,
  /** Color of accordion background */
  background: PropTypes.oneOf(['white'])
};

export default WrappedAccordion;
export { WrappedAccordionItem as AccordionItem };
